/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRightFromArc = createReactComponent("outline", "arrow-right-from-arc", "IconArrowRightFromArc", [["path", { "d": "M15 12h-12", "key": "svg-0" }], ["path", { "d": "M7 8l-4 4l4 4", "key": "svg-1" }], ["path", { "d": "M12 21a9 9 0 0 0 0 -18", "key": "svg-2" }]]);

export { IconArrowRightFromArc as default };
//# sourceMappingURL=IconArrowRightFromArc.mjs.map
